export default __webpack_public_path__ + "static/media/TaskeemLogo.c7aade7d.svg";